//Global.JS
//ACCESS Functions & Variables using $global.nameOfMethod/Function
var getUrl = window.location;
var baseUrl = getUrl.protocol + "//" + getUrl.host +'/';
var MIX_AWS_BASE_URL =  process.env.MIX_AWS_BASE_URL;

window.Vue = require('vue');
    Vue.prototype.$global = {

        base_url : baseUrl,
        user_name : '',
        user_company_payment_engine : '',
        user_company : '',
        user_company_email : '',
        user_vr_corp : '',
        user_vr_balance : '',
        heirarchy_system : '',
        nextMaker : '',
        nextChecker : '',
        nextApprover : '',
        receiptImage : '',
        aws_base_url : MIX_AWS_BASE_URL,
        // aws_base_url : 'https://finjabusiness-pwa.s3.eu-west-1.amazonaws.com/', /* Live URL */

        getName(){
            axios.get('/api/getCurrentUserName').then(res => {
                if(res.data.status == 200){
                    this.user_name =  res.data.name;
                }
            });
        },

        checkIdExist(id, array){
            for(var i=0; i<array.length; i++){
                if(array[i].id === id){
                    return array[i];
                }
            }
        },

    };
